export enum DocumentationAreaActorOrderRetrievalMethodNames {
  AUTOMATIC_EXTRACTION = "automatic_extraction",
  MANUAL_UPLOAD = "manual_upload",
}
